<template>
  <div class="page-wrap">
    <div class="wraper">
      <img class="t-img" :src="img" />
      <div class="content-wrap">
        <div class="row" v-for="(item, index) in questionList" :key="index">
          <div class="question">
            <tr>
              <td class="question_icon"></td>
              <td class="question_title">{{item.sort + '.' + item.question}}</td>
            </tr>
          </div>
          <div class="answer">
            <tr>
              <td class="answer_icon"></td>
              <td class="answer_info" v-html="item.answer"></td>
            </tr>
          </div>
        </div>
      </div>
    </div>
   <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      questionList: null,
      img: `${process.env.BASE_URL}ImgFiles/top-cjwt_02.jpg`,
    };
  },
  created() {
    this.$http.post("/api/dataapi/faq?whid=wenhua").then((res) => {
      if (res.status != 200 || !res.data) return;
      this.questionList = res.data;
    });
  },
};
</script>

<style scoped>
.page-wrap {
  
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.content-wrap {
  margin-top: 0.6773rem;
  padding: 0 0.3386rem 1.1rem 0.3386rem;
  text-align: justify;
}
.row {
  margin-bottom: 1.1rem;
  font-size: 0.58rem;
  color: #393939;
}

.row:last-of-type {
  margin-bottom: 0;
}

.question {
  font-weight: bold;
  margin-bottom: 0.4233rem;
}

.question_icon {
  height: 0.58rem;
  width: 0.58rem;
  display: inline-block;
  background: url(../../assets/img/Q.png) no-repeat center/auto;
  background-size: 100% 100%;
  margin-top: 25%;
}

.answer_icon {
  height: 0.58rem;
  width: 0.58rem;
  display: inline-block;
  background: url(../../assets/img/A.png) no-repeat center/auto;
  background-size: 100% 100%;
  margin-top: 25%;
}
tr td {
  vertical-align: middle;
  line-height: 1rem;
}
tr td:last-child {
  padding-left: 0.21rem;
}
tr {
  margin-bottom: 0.4233rem;
}
</style>